import React from 'react'
import PropTypes from 'prop-types'

/**
@description Renders a round column cell

@param {string} time. The round time.

@param {bool} isDailyTotal. True if row is daily total row.

@returns {function} RoundColumnCell
*/

export default function RoundColumnCell(props) {
  const { isDailyTotal, time } = props

  const roundColumnStyles = isDailyTotal
    ? { ...styles.roundColumn, fontWeight: 700 }
    : styles.roundColumn

  return <div style={roundColumnStyles}>{time}</div>
}

RoundColumnCell.propTypes = {
  isDailyTotal: PropTypes.bool,
  time: PropTypes.string.isRequired,
}

const styles = {
  roundColumn: {
    lineHeight: '22px',
    width: 90,
  },
}
